import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=1fafcbae&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fafcbae')) {
      api.createRecord('1fafcbae', component.options)
    } else {
      api.reload('1fafcbae', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=1fafcbae&", function () {
      api.rerender('1fafcbae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ia2tRK0xG0TY/JS/videoIframe.vue"
export default component.exports